{
  "pageTitle": "Holidays",
  "holidays": {
    "title": "Company Holidays",
    "addNew": "+ New Holiday",
    "columns": {
      "date": "Date",
      "name": "Holiday Name",
      "actions": "Actions"
    },
    "form": {
      "titleCreate": "New Holiday",
      "titleEdit": "Edit Holiday",
      "dateLabel": "Date",
      "nameLabel": "Holiday Name",
      "namePlaceholder": "e.g. New Year's Day",
      "errors": {
        "dateRequired": "Date is required.",
        "nameRequired": "Holiday name is required."
      }
    },
    "empty": {
      "title": "No holidays yet",
      "hint": "Add national or company-specific holidays."
    },
    "failedToLoad": "Failed to load holidays.",
    "toasts": {
      "created": "Holiday added.",
      "updated": "Holiday updated.",
      "deleted": "Holiday deleted.",
      "saveFailed": "Failed to save holiday. Please try again.",
      "deleteFailed": "Failed to delete holiday. Please try again."
    },
    "confirm": {
      "delete": "Delete holiday \"{{name}}\"?"
    },
    "import": {
      "button": "Import Armenia holidays",
      "importing": "Importing…",
      "yearLabel": "Import year",
      "success": "Imported {{imported}} holiday(s), skipped {{skipped}}.",
      "failed": "Failed to import holidays. Please try again.",
      "invalidYear": "Enter a year between 2000 and 2100."
    }
  },
  "timeOff": {
    "title": "Employee Time Off",
    "addNew": "+ New Time Off",
    "columns": {
      "employee": "Employee",
      "type": "Type",
      "month": "Month",
      "startDate": "Start",
      "endDate": "End",
      "carryover": "From Last Year",
      "remainingDays": "Days Left",
      "note": "Note",
      "actions": "Actions"
    },
    "carryoverHint": "Includes {{days}} day(s) carried over from the previous year",
    "types": {
      "vacation": "Vacation",
      "sick_leave": "Sick Leave",
      "unpaid_leave": "Unpaid Leave",
      "business_trip": "Business Trip",
      "day_off": "Day off"
    },
    "status": {
      "active": "On leave",
      "ended": "Ended",
      "upcoming": "Not started"
    },
    "filter": {
      "label": "Filter records",
      "yearLabel": "Year",
      "all": "All",
      "emptyTitle": "No matching records",
      "emptyHint": "No time-off records match the selected filters.",
      "allMonths": "All months",
      "allEmployees": "All employees"
    },
    "months": {
      "1": "January",
      "2": "February",
      "3": "March",
      "4": "April",
      "5": "May",
      "6": "June",
      "7": "July",
      "8": "August",
      "9": "September",
      "10": "October",
      "11": "November",
      "12": "December"
    },
    "form": {
      "titleCreate": "New Time Off",
      "titleEdit": "Edit Time Off",
      "employeeLabel": "Employee",
      "employeePlaceholder": "Select employee",
      "typeLabel": "Type",
      "startDateLabel": "Start Date",
      "endDateLabel": "End Date",
      "noteLabel": "Note (optional)",
      "notePlaceholder": "Optional notes…",
      "errors": {
        "employeeRequired": "Employee is required.",
        "typeRequired": "Type is required.",
        "startDateRequired": "Start date is required.",
        "endDateRequired": "End date is required.",
        "endBeforeStart": "End date must be on or after the start date."
      },
      "daysCount": "Total: {{count}} day(s) — start and end dates inclusive."
    },
    "empty": {
      "title": "No time-off records",
      "hint": "Track employee vacations, sick leave, and other absences."
    },
    "failedToLoad": "Failed to load time-off records.",
    "toasts": {
      "created": "Time off recorded.",
      "updated": "Time off updated.",
      "deleted": "Time off deleted.",
      "saveFailed": "Failed to save time off. Please try again.",
      "deleteFailed": "Failed to delete time off. Please try again."
    },
    "confirm": {
      "delete": "Delete this time-off record?"
    },
    "tabs": {
      "records": "Time Off Records",
      "calc": "Vacation Calculation"
    }
  },
  "vacationCalc": {
    "title": "Vacation Calculation",
    "filter": {
      "label": "Filter calculation rows",
      "all": "All",
      "withCarryover": "With carryover",
      "overdrawn": "Overdrawn"
    },
    "columns": {
      "carryover": "Carryover",
      "annual": "Annual",
      "accrued": "Accrued to Date",
      "used": "Used",
      "unpaid": "Unpaid Leave",
      "availableNow": "Available Now",
      "remaining": "Year Total Left"
    },
    "empty": {
      "title": "Nothing to show",
      "hint": "No employees match the selected filter."
    },
    "explainer": "Each employee earns {{annual}} vacation days per year, accrued gradually — ({{annual}} ÷ days in the year) per elapsed day, so by late January ≈1.6 days are earned. “Available now” = carryover + accrued to date − used; “Year total left” counts the full annual allowance. Carryover from previous years is entered on the employee card. Only WORKING days of “Vacation” records count as used — non-working weekdays per the company schedule and company holidays are free, and overlapping records are not double-counted. The “Unpaid leave” column is informational only — it never affects the vacation balance.",
    "carryoverEdit": {
      "ariaLabel": "Carryover days",
      "saved": "Carryover saved.",
      "saveFailed": "Failed to save. Please try again."
    }
  },
  "aria": {
    "loading": "Loading…",
    "deleteHoliday": "Delete holiday",
    "editHoliday": "Edit holiday",
    "deleteTimeOff": "Delete time off",
    "editTimeOff": "Edit time off"
  }
}
